export default (node) => {
  /**
   * Data + elements
   */
  const swiperContainer = node.querySelector('.swiper-container');

  /**
   * Functions
   */
  const initSwiper = () => {
    new Swiper(swiperContainer, {
      spaceBetween: 24,
      grabCursor: true,
      watchOverflow: true,
      centerInsufficientSlides: true,
      breakpoints: {
        // Screens <768px
        0: {
          slidesPerView: 1.5,
        },
        // Screens ≥768px (md and up)
        768: {
          slidesPerView: 'auto',
        },
      },
    });
  };

  /**
   * Init
   */
  const init = () => {
    if (swiperContainer) {
      initSwiper();
    }
  };

  init();
};
